"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var LL_BRAND_COLORS = {
    white: '#ffffff',
    pale_gray: '#f1f3f4',
    gray: '#D2D9DB',
    deep_gray: '#4F6475',
    charcoal: '#2F4149',
    navy: '#013A53',
    teal: '#00617D',
    deep_aqua: '#23788B',
    pale_aqua: '#E9F2F3',
    pale_emerald: '#ECF5EC',
    emerald: '#208345',
    deep_emerald: '#135E2F',
    lime: '#90D432',
    pale_tangerine: '#FFF6E7',
    tangerine: '#FEA511',
    cardinal: '#CC4039',
    deep_cardinal: '#952C26',
    pale_cardinal: '#FFE9E8',
};
var LL_UI_COLORS = {
    // Base Styles
    gray_base: LL_BRAND_COLORS.pale_gray,
    // Border Styles
    border_color: LL_BRAND_COLORS.gray,
    box_shadow: (0, tinycolor2_1.default)(LL_BRAND_COLORS.charcoal)
        .setAlpha(0.6)
        .toRgbString(),
    // Text Colors
    main_content_text: LL_BRAND_COLORS.navy,
    helper_text: LL_BRAND_COLORS.deep_gray,
    // Interaction Colors
    interactive: LL_BRAND_COLORS.deep_aqua,
    interactive_hover: LL_BRAND_COLORS.navy,
    white_highlight: LL_BRAND_COLORS.pale_aqua,
    disabled: LL_BRAND_COLORS.gray,
    // Icon Colors
    icon_display_only: LL_BRAND_COLORS.navy,
    icon_active: LL_BRAND_COLORS.deep_aqua,
    icon_hover: LL_BRAND_COLORS.gray,
    icon_disabled: LL_BRAND_COLORS.gray,
    icon_selected: LL_BRAND_COLORS.navy,
    error: LL_BRAND_COLORS.cardinal,
};
var LL_UI_BUTTON_COLORS = {
    // Disabled button colors
    disabled_btn: LL_BRAND_COLORS.gray,
    disabled_btn_text: LL_BRAND_COLORS.deep_gray,
    disabled_btn_text_hover: LL_BRAND_COLORS.deep_cardinal,
    // Primary button colors
    primary_btn: LL_BRAND_COLORS.deep_aqua,
    primary_btn_hover: LL_BRAND_COLORS.navy,
    // Required button colors
    required_btn: LL_BRAND_COLORS.emerald,
    required_btn_hover: LL_BRAND_COLORS.deep_emerald,
    // Caution button colors
    caution_btn: LL_BRAND_COLORS.pale_gray,
    caution_btn_text: LL_BRAND_COLORS.deep_gray,
    caution_btn_hover: LL_BRAND_COLORS.gray,
    caution_btn_hover_border: LL_BRAND_COLORS.navy,
    caution_btn_hover_text: LL_BRAND_COLORS.navy,
    // Additional button colors
    additional_btn: LL_BRAND_COLORS.white,
    additional_btn_text: LL_BRAND_COLORS.deep_gray,
    additional_btn_hover: LL_BRAND_COLORS.pale_gray,
    additional_btn_border: LL_BRAND_COLORS.gray,
    additional_btn_hover_border: LL_BRAND_COLORS.navy,
    // Permanent button colors
    permanent_btn: LL_BRAND_COLORS.cardinal,
    permanent_btn_text: LL_BRAND_COLORS.white,
    permanent_btn_hover: LL_BRAND_COLORS.deep_cardinal,
    // permanent button colors
    significant_btn: LL_BRAND_COLORS.pale_emerald,
    significant_btn_border: LL_BRAND_COLORS.emerald,
    significant_btn_text: LL_BRAND_COLORS.navy,
    significant_btn_hover: LL_BRAND_COLORS.emerald,
    // Selected button colors
    selected_btn: LL_BRAND_COLORS.pale_aqua,
    selected_btn_text: LL_BRAND_COLORS.navy,
    selected_btn_hover: LL_BRAND_COLORS.pale_gray,
    selected_btn_border: LL_BRAND_COLORS.navy,
    // Selected button colors
    unselected_btn: LL_BRAND_COLORS.white,
    unselected_btn_text: LL_BRAND_COLORS.deep_gray,
    unselected_btn_border: LL_BRAND_COLORS.gray,
    unselected_btn_hover: LL_BRAND_COLORS.pale_gray,
    unselected_btn_border_hover: LL_BRAND_COLORS.navy,
    unselected_btn_text_hover: LL_BRAND_COLORS.navy,
    // Revoked button colors
    revoked_btn: LL_BRAND_COLORS.pale_tangerine,
    revoked_btn_border: LL_BRAND_COLORS.tangerine,
    revoked_btn_text: LL_BRAND_COLORS.navy,
};
var STATE_COLORS = {
    open: LL_BRAND_COLORS.tangerine,
    pending: LL_BRAND_COLORS.tangerine,
    in_progress: LL_BRAND_COLORS.emerald,
    completed: LL_BRAND_COLORS.deep_aqua,
    cancelled: LL_BRAND_COLORS.gray,
    denied: LL_BRAND_COLORS.cardinal,
    approved: LL_BRAND_COLORS.emerald,
};
var APP_COLORS = {
    white: 'white',
    transparent: 'rgba(0,0,0,0)',
    opaqueGray: 'rgba(246, 248, 250, 0.85)',
    opaqueBlue: 'rgba(0, 63, 106, 0.8)',
    opaqueBlack: 'rgba(0, 0, 0, 0.8)',
    veryOpaqueWhite: 'rgba(255,255,255, 0.2)',
    opaqueWhite: 'rgba(255,255,255, 0.85)',
    blue_900: '#00273E',
    blue_800: '#003F6A',
    blue_700: '#005696',
    blue_600: '#016EC1',
    blue_500: '#0186ED',
    blue_400: '#309DF1',
    blue_300: '#63B6F4',
    blue_200: '#8ECBF8',
    blue_100: '#BDE2FB',
    blue_000: '#ECF9FF',
    livid_900: '#182833',
    livid_800: '#1F394C',
    livid_700: '#2D506B',
    livid_600: '#3A6586',
    livid_500: '#4679A2',
    livid_400: '#739DBE',
    livid_300: '#ACCBE2',
    livid_200: '#C5DCED',
    livid_100: '#E3F1FA',
    livid_000: '#F5FAFD',
    gray_900: '#24292D',
    gray_800: '#2F363D',
    gray_700: '#434D56',
    gray_600: '#576069',
    gray_500: '#69737D',
    gray_400: '#949DA5',
    gray_300: '#D1D5D9',
    gray_200: '#E0E4E8',
    gray_100: '#F6F8FA',
    gray_000: '#FAFBFC',
    green_900: '#33691E',
    green_800: '#4E8627',
    green_700: '#69A430',
    green_600: '#83C139',
    green_500: '#9EDE42',
    green_400: '#B0E463',
    green_300: '#C2EA84',
    green_200: '#D5EFA5',
    green_100: '#E7F5C6',
    green_000: '#F9FBE7',
    yellow_900: '#B97000',
    yellow_800: '#C68B17',
    yellow_700: '#D3A517',
    yellow_600: '#E0C017',
    yellow_500: '#EDDA00',
    yellow_400: '#F1E12E',
    yellow_300: '#F4E85C',
    yellow_200: '#F8EF8B',
    yellow_100: '#FBF6B9',
    yellow_000: '#FFFDE7',
    red_000: '#FFF3F5',
    red_100: '#FAD2D0',
    red_200: '#F5B0AB',
    red_300: '#F18F86',
    red_400: '#EC6D61',
    red_500: '#E74C3C',
    red_600: '#CF3F34',
    red_700: '#B7322D',
    red_800: '#9E2525',
    red_900: '#86181D',
    orange_500: '#ffa000',
};
var ACTIVITY_COLORS = {
    snack: '#4CAF50',
    snackText: (0, tinycolor2_1.default)('#4CAF50').darken(35),
    meal: '#CDDC39',
    mealText: (0, tinycolor2_1.default)('#CDDC39').darken(35),
    personal: '#009688',
    personalText: (0, tinycolor2_1.default)('#009688').darken(35),
    other: '#B1BFD4',
    otherText: (0, tinycolor2_1.default)('#B1BFD4').darken(35),
};
var OTHER_COLORS = {
    errorLight: APP_COLORS.red_200,
};
exports.default = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, OTHER_COLORS), ACTIVITY_COLORS), STATE_COLORS), APP_COLORS), LL_BRAND_COLORS), LL_UI_COLORS), LL_UI_BUTTON_COLORS);
